export default function WhySection() {
  const reasons = [
    {
      icon: "ri-checkbox-circle-line",
      title: "Trusted Product Lists",
      desc: "Curated and verified product catalogs updated regularly with the latest finds",
      imageUrl: "https://readdy.ai/api/search-image?query=Organized%20product%20catalog%20displayed%20on%20warm%20minimalist%20desk%20with%20checklist%20and%20product%20samples%2C%20soft%20natural%20lighting%2C%20clean%20trustworthy%20aesthetic%2C%20editorial%20product%20photography%2C%20high%20detail%2C%20warm%20cream%20tones&width=600&height=400&seq=why-trusted-001&orientation=landscape"
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Cheapest Sourcing Methods",
      desc: "Compare prices across suppliers to find the absolute best deals available",
      imageUrl: "https://readdy.ai/api/search-image?query=Price%20comparison%20concept%20with%20magnifying%20glass%20over%20product%20price%20tags%20on%20warm%20minimalist%20desk%2C%20soft%20diffused%20lighting%2C%20money%20saving%20aesthetic%2C%20editorial%20business%20photography%2C%20high%20detail%2C%20warm%20beige%20tones&width=600&height=400&seq=why-cheapest-002&orientation=landscape"
    },
    {
      icon: "ri-user-star-line",
      title: "Reliable Buying Agents",
      desc: "Work with pre-screened agents who handle ordering, QC, and shipping",
      imageUrl: "https://readdy.ai/api/search-image?query=Professional%20handshake%20and%20package%20inspection%20concept%20on%20warm%20minimalist%20workspace%2C%20soft%20natural%20lighting%2C%20trust%20and%20partnership%20aesthetic%2C%20editorial%20business%20photography%2C%20high%20detail%2C%20warm%20sand%20tones&width=600&height=400&seq=why-agents-003&orientation=landscape"
    },
    {
      icon: "ri-global-line",
      title: "Easy International Shopping",
      desc: "Designed for global buyers with English support and transparent pricing",
      imageUrl: "https://readdy.ai/api/search-image?query=World%20globe%20with%20shopping%20bag%20and%20international%20shipping%20labels%20on%20warm%20minimalist%20desk%2C%20soft%20morning%20light%2C%20global%20commerce%20aesthetic%2C%20editorial%20lifestyle%20photography%2C%20high%20detail%2C%20warm%20neutral%20tones&width=600&height=400&seq=why-global-004&orientation=landscape"
    }
  ];

  return (
    <section className="py-14 md:py-20 px-4 md:px-8 lg:px-12 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-semibold text-foreground-900 mb-3">
            Why Users Search "Mulebuy Spreadsheet"
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Thousands of savvy shoppers turn to spreadsheet-based sourcing every month. Here is what they are looking for.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {reasons.map((r) => (
            <div key={r.title} className="bg-background-50 rounded-lg overflow-hidden group hover:shadow-sm transition-shadow cursor-default">
              <div className="w-full h-40 md:h-48 overflow-hidden">
                <img
                  src={r.imageUrl}
                  alt={r.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5 text-center">
                <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center mx-auto mb-3 rounded-full bg-accent-100">
                  <i className={`${r.icon} text-accent-600 text-lg md:text-xl`}></i>
                </div>
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-1.5">{r.title}</h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{r.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}